module.exports = __webpack_public_path__ + "img/m3.6b3e6dab.png";